interface IMatch {
	round: number;
	homeTeamId: number;
	awayTeamId: number;
	homeTeamAbbr: string;
	awayTeamAbbr: string;
	homeTeamColor: string;
	awayTeamColor: string;
	start_at: string;
	venue: string;
}

export class Squad {
	public id: number = 0;
	public fullName: Record<string, string> = {};
	public shortName: string = "";
	public adFirstBtnLink: Record<string, string> = {};
	adFirstBtnTxt: Record<string, string> = {};
	adFirstImg: Record<string, string> = {};
	adFirstImgMobile: Record<string, string> = {};
	adFirstTitle: Record<string, string> = {};
	adMainImg: Record<string, string> = {};
	adMainImgMobile: Record<string, string> = {};
	adMainTitle: Record<string, string> = {};
	adMainVideo: Record<string, string> = {};
	adSecondBtnLink: Record<string, string> = {};
	adSecondBtnTxt: Record<string, string> = {};
	adSecondImg: Record<string, string> = {};
	adSecondImgMobile: Record<string, string> = {};
	adSecondTitle: Record<string, string> = {};
	adThirdBtnLink: Record<string, string> = {};
	adThirdBtnTxt: Record<string, string> = {};
	adThirdImg: Record<string, string> = {};
	adThirdImgMobile: Record<string, string> = {};
	adThirdTitle: Record<string, string> = {};

	match?: IMatch = {
		round: 0,
		awayTeamId: 0,
		homeTeamId: 0,
		awayTeamAbbr: "",
		awayTeamColor: "",
		homeTeamAbbr: "",
		homeTeamColor: "",
		start_at: "",
		venue: "",
	};

	constructor(args: Squad) {
		Object.assign(this, args);
	}
}
